import * as React from "react";
import { InfoLabel, StyledTextField } from "./info_label";

export default function HelpedTextField({
  label,
  info,
  value,
  onChange,
  tooltipPlacement = "top",
  iconSize = "medium",
  ...props
}) {
  return (
    <StyledTextField
      InputLabelProps={{ shrink: true }}
      label={
        info ? <InfoLabel label={label} info={info} tooltipPlacement={tooltipPlacement} iconSize={iconSize} /> : label
      }
      sx={{ ...props.sx }}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
}
